import { PartfolioGalleryComponent } from './portfolio-gallery.component';
import { PartfolioItemComponent } from './portfolio-item.component';

export const PORTFOLIO_ROUTER = [
  { path: 'gallery', component: PartfolioGalleryComponent},
  { path: 'description', component: PartfolioItemComponent}
];



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/portfolio/portfolio.routes.ts